import { useId } from 'react'
// Utils
import classnames from 'classnames'

import styles from './sliderRangeItem.module.scss'

interface SliderRangeItemProps {
  title: string
  value: string
  sliderPercentage: number
  className?: string
}

export const SliderRangeItem = ({ className = '', ...props }: SliderRangeItemProps) => {
  const wrapClasses = classnames(styles.sliderRangeWrap, className)
  const id = useId()
  return (
    <div className={wrapClasses}>
      <label className={styles.sliderRangeTitle} htmlFor={id}>
        {props.title} : {props.value}
      </label>
      <input
        type="range"
        min="0"
        max="100"
        value={props.sliderPercentage}
        className={styles.rangeSlider}
        disabled
        id={id}
      />
    </div>
  )
}

export default SliderRangeItem
